import Container from '../../atoms/Container';
// import PageHeader from '../../molecules/Header';
import { Typography } from '../../molecules/Typography';
import { ExerciseList } from '../../organism/ExerciseList';

import { useExerciseHook } from '../../../hooks/exercise';
import { ExerciseAction, IExercise } from '../../../models/exercise';
import { Button } from '../../atoms/Button';
import { AnswersHolder } from '../../molecules/AnswersHolder';
import ExercisePagination from '../../molecules/ExercisePagination';
// import PrintComponent from '../../organism/PrintComponent';
// import { Colors } from '../../../models/disciplines';
// import { DnaIcon } from 'morpheus-ui';
import { Fragment, useEffect } from 'react';
import ContentLoader from 'react-content-loader';
//import { getDisciplineIcon } from '../../../utils/discipline';
import NewPrintComponent from '../../organism/PrintComponent/newPrintComponent';

import { DnaIcon } from 'morpheus-ui';
import { Colors } from '../../../models/disciplines';
import { getDisciplineIcon } from '../../../utils/discipline';
import { usePrintComponentStore } from '../../organism/PrintComponent/store/usePrintComponentStore';
import ExercisePaper from '../PrintPaper/exercises';
import useGetBadgeScores from '../../../../modules/Disciplines/hooks/useGetBadgeScores';
import { useUserStore } from '../../../../modules/Auth/stores/authStore';
import { useTimedFunction } from '../../../../modules/Disciplines/hooks/useTimedFunctino';
import FreemiumLockContent from '../../organism/FreemiumLockModal/LockContent';
import { useAccess } from '../../../accessControl/useAccess';

interface ExerciseProps {
  title?: string | null;
  discipline?: string | null;
  exercises: IExercise[];
  initialPage?: number;
  exerciseType?: 'default' | 'revision';
  showTotalExercises?: boolean;
  showExerciseNavigation?: boolean;
  showContentList?: boolean;
  isLoading?: boolean;
  noContainer?: boolean;
  lastPageLabel?: string;
  onLastPageClick?: () => void;
  onPageChange: (page: number) => void;
  onExerciseChange: (exercise: IExercise, action?: ExerciseAction) => void;
  onClickContentList?: () => void;
  onEndRevision?: () => void;
}

const Exercise = ({
  title = null,
  discipline = null,
  exercises,
  initialPage = 0,
  exerciseType = 'default',
  showTotalExercises = false,
  showExerciseNavigation = true,
  showContentList = false,
  isLoading = false,
  noContainer = false,
  lastPageLabel,
  onLastPageClick,
  onPageChange,
  onExerciseChange,
  onClickContentList = () => {},
  onEndRevision = () => {},
}: ExerciseProps) => {
  const { user } = useUserStore();
  const { isContentLocked } = useAccess();

  const { setData } = usePrintComponentStore();

  const {
    currentPage,
    isOpenPrint,
    goToExercise,
    goToNextExercise,
    goToPreviousExercise,
    checkExercise,
    scrollToBottom,
    setIsOpenPrint,
  } = useExerciseHook(initialPage);

  const {
    getBadgeScores,
    badgeScore,
    isPending: isPendingBadgeScores,
  } = useGetBadgeScores();

  const { start, cancel } = useTimedFunction(
    async () => {
      if (!user?.id) return;

      getBadgeScores(
        {
          externalId: user?.id,
          externalContent: currentExercise.id,
          externalContentOrigin: 'navegation',
        },
        (data) => {
          if (!data?.didPoint) return;

          cancel();
        }
      );
    },
    {
      times: 5,
      delayInSeconds: 3,
    }
  );

  const totalExercises = exercises.length;
  const currentExercise =
    totalExercises > 0 ? exercises[currentPage] : ({} as IExercise);

  const isExerciseLocked = isContentLocked(currentExercise);

  const isAllExercisesDone =
    exercises.filter((exercise) => exercise.done).length >= totalExercises;

  const handleCheck = () => {
    scrollToBottom(
      onExerciseChange(checkExercise(currentExercise), 'verifyAnswer')
    );

    start();
  };

  useEffect(() => {
    if (!user?.id || !currentExercise.id) return;
    getBadgeScores({
      externalId: user?.id,
      externalContent: currentExercise.id,
      externalContentOrigin: 'navegation',
    });
  }, [user?.id, currentExercise.id]);

  const Wrapper = noContainer ? 'div' : Container;

  return (
    <Wrapper>
      {!currentExercise || !currentExercise.alternatives ? (
        <Fragment>
          <ContentLoader
            backgroundColor={'#a7adba'}
            foregroundColor={'#c0c5ce'}
            viewBox='0 0 500 30'
          >
            <rect x='0' y='2' rx='2' ry='2' width='100' height='15' />
          </ContentLoader>
          <ContentLoader
            backgroundColor={'#a7adba'}
            foregroundColor={'#c0c5ce'}
            viewBox='0 0 500 80'
          >
            <rect x='0' y='2' rx='2' ry='2' width='100%' height='70' />
          </ContentLoader>
          {Array.from({ length: 5 }, (_, index) => (
            <ContentLoader
              key={`${index}_loader`}
              backgroundColor={'#a7adba'}
              foregroundColor={'#c0c5ce'}
              viewBox='0 0 500 24'
            >
              <rect x='0' y='2' rx='2' ry='2' width='100%' height='20' />
            </ContentLoader>
          ))}
        </Fragment>
      ) : (
        <div className='flex flex-col gap-xxl pb-20'>
          <NewPrintComponent
            type='exercise'
            isOpen={isOpenPrint}
            onClose={() => setIsOpenPrint(false)}
            title={title ?? ''}
            subtitle={discipline ?? 'Interdisciplinar'}
          >
            <ExercisePaper
              cols='split'
              size='default'
              color={(discipline as Colors) ?? 'interdisciplinar'}
              iconType='svg'
              icon={getDisciplineIcon(discipline || '') || DnaIcon}
              title={title ?? ''}
              module={discipline ?? 'Interdisciplinar'}
            />
          </NewPrintComponent>
          {showTotalExercises && (
            <Typography size='small'>
              {`${totalExercises} exercícios`}
            </Typography>
          )}
          {showExerciseNavigation && (
            <div className='flex flex-col gap-md'>
              <AnswersHolder
                answers={exercises}
                onSelectedAnswer={(index) => {
                  goToExercise(index);
                  onPageChange(index);
                }}
              />
              <div className='flex justify-between'>
                <Typography size='small'>
                  Navegue pela lista de exercícios
                </Typography>
                {exerciseType !== 'revision' && (
                  <Button
                    variant='text'
                    LeftIcon='print'
                    size='small'
                    onClick={() => {
                      setData(exercises);
                      setIsOpenPrint(true);
                    }}
                  >
                    <Typography>Imprimir lista de exercícios</Typography>
                  </Button>
                )}
              </div>
            </div>
          )}

          {isExerciseLocked ? (
            <FreemiumLockContent className='max-w-[520px]' />
          ) : (
            <div className='flex items-center justify-between'>
              <ExerciseList
                data={exercises}
                isLoading={isLoading}
                tryAgainEnabled={exerciseType !== 'revision'}
                onExerciseChange={(exercise, action) => {
                  onExerciseChange(exercise, action);
                }}
                badgeInfos={{ ...badgeScore, isPendingBadgeScores }}
              />
            </div>
          )}
        </div>
      )}
      <ExercisePagination
        page={currentPage}
        totalPages={totalExercises}
        currentExercise={currentExercise}
        showContentList={showContentList}
        enableRevision={exerciseType === 'revision' && isAllExercisesDone}
        isLoading={isLoading}
        inline={noContainer}
        lastPageLabel={lastPageLabel}
        onLastPageClick={onLastPageClick}
        onPrevious={() => goToPreviousExercise(totalExercises, onPageChange)}
        onNext={() => goToNextExercise(totalExercises, onPageChange)}
        onCheck={handleCheck}
        onClickContentList={() => onClickContentList()}
        onEndRevision={() => onEndRevision()}
        currentPosition={currentPage + 1}
        totalExercises={totalExercises}
      />
    </Wrapper>
  );
};

export default Exercise;
